import { useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import HiddenFieldExplanation from '../hidden-field-description/HiddenFieldDescription';
import styles from './editable-image.module.less';
import { Spinner } from '@sb1/ffe-spinner-react';
import { isAndroid } from '../../utils';
import { useSelector } from 'react-redux';
import { getUserAgent } from '../../utils/browserDetector';
import { compressImage } from '../../utils/compress-image-utils';

const defaultAccept = ['image/jpeg', 'image/png', 'image/webp'];

const UploadImageBox = ({
    className = '',
    uploadHandler,
    onDropRejected,
    placeholder,
    placeholderLoading,
    setIsCropping,
    accept = defaultAccept,
}) => {
    const [loading, setLoading] = useState(false);
    const userAgent = useSelector((state) => getUserAgent(state));
    const androidFileRef = useRef(null);

    const onDropAccepted = (files) => {
        if (!files || files.length === 0) {
            return;
        }

        setLoading(true);

        compressImage(files[0])
            .then((compressedFile) => uploadHandler(compressedFile))
            .then(() => {
                setLoading(false);
                if (setIsCropping) {
                    setIsCropping(true);
                }
            })
            .catch(() => {
                setLoading(false);
                if (setIsCropping) {
                    setIsCropping(false);
                }
            });
    };

    const setDefaultState = () => {
        setLoading(false);
    };

    const onRejectDrop = () => {
        setDefaultState();
        onDropRejected();
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDropRejected: onRejectDrop,
        onDropAccepted,
        multiple: false,
        accept: accept.reduce((acc, cur) => ({ ...acc, [cur]: [] }), {}),
    });

    const defaultPlaceHolderLoading = (
        <>
            <Spinner />
            <p>Laster opp</p>
        </>
    );

    if (isAndroid(userAgent)) {
        return (
            <button className={[styles.dropZone, className].join(' ')} type="button" aria-label="Last opp bilde">
                <input
                    onChange={(e) => onDropAccepted(e.target.files)}
                    ref={androidFileRef}
                    className={styles.hidden}
                    type="file"
                    accept={accept.join(';')}
                    aria-label="Klikk her for å velge bilde du vil laste opp"
                />
                <div className={styles.innerDropZone} onClick={() => androidFileRef?.current?.click()}>
                    {loading ? placeholderLoading || defaultPlaceHolderLoading : placeholder}
                </div>
            </button>
        );
    }

    return (
        <>
            <button
                {...getRootProps()}
                role={null}
                className={[styles.dropZone, className].join(' ')}
                type="button"
                aria-label="Last opp bilde"
            >
                <input {...getInputProps()} aria-label="Klikk her for å velge bilde du vil laste opp" />
                <div className={styles.innerDropZone}>
                    {loading ? placeholderLoading || defaultPlaceHolderLoading : placeholder}
                </div>
                <HiddenFieldExplanation htmlFor="editableImageInput" text="Legg inn bilde" />
            </button>
        </>
    );
};

export default UploadImageBox;
